import React, { Fragment } from 'react';
import values from 'lodash/values';
import mapValues from 'lodash/mapValues';
import upperFirst from 'lodash/upperFirst';
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import omit from 'lodash/omit';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';

import SERVER_ERRORS from 'constants/server-errors';
import { DEFAULT_GUIDE_LABEL } from 'hooks/guide-label';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
const NO_PERMISSION = 'You do not have permission to perform this action';
const UNAUTHORIZED = 'Please sign in to perform this action';

const formatArrayMessages = (response) =>
  mapValues(response, (errors, fieldName) =>
    fieldName === 'base' ? errors[0] : upperFirst(`${fieldName.replace(/([A-Z])/g, ' $1').toLowerCase()} ${errors[0]}`),
  );

export const getErrorMessage = (response = {}, options = {}) => {
  const { status, data } = response;

  let errorMessage = '';

  if (status === 500) {
    // It causes from server, not meaning for client so we don't need to show it
    return DEFAULT_ERROR_MESSAGE;
  } else if (typeof data === 'string') {
    errorMessage = data;
  } else if (data?.errorCode && SERVER_ERRORS[data.errorCode]) {
    errorMessage = SERVER_ERRORS[data.errorCode].message({ ...options, message: data.message });
  } else if (isPlainObject(data)) {
    if (isPlainObject(data.errors)) {
      errorMessage = values(formatArrayMessages(data.errors))[0];
    } else {
      const omittedErrorCodeData = pickBy(omit(data, ['errorCode']), 'length');

      const firstError = values(omittedErrorCodeData)[0];

      if (isArray(firstError)) {
        errorMessage = values(formatArrayMessages(omittedErrorCodeData))[0];
      }

      if (typeof firstError === 'string') {
        errorMessage = firstError;
      }
    }
  }

  if (isEmpty(errorMessage)) {
    if (status === 403) {
      return NO_PERMISSION;
    } else if (status === 401) {
      return UNAUTHORIZED;
    } else {
      return DEFAULT_ERROR_MESSAGE;
    }
  } else {
    return errorMessage;
  }
};

export const charityDonationMessage = (charityName, percent, guideLabel = DEFAULT_GUIDE_LABEL) => (
  <Fragment>
    When you schedule this call with our {guideLabel.toLowerCase()}, <b>{percent}%</b> of the revenue will be donated
    to&nbsp;
    <b>{charityName}</b>. Your participation not only helps you gain valuable insights but also supports a great cause!
  </Fragment>
);
